import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'modify_flightselector';
export const route = 'modify_flightselector/[[...token]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "modify_flightselector" */
/* webpackPrefetch: true */
'../components/FlightSelectorPage')));